module.exports = __webpack_public_path__ + "img/6.a9b2eb14.jpg";